import axios from 'axios';

// Determine API base URL (supports Cloudflare tunnel + local dev)
function getBaseURL() {
  const host = window.location.hostname;
  if (host && host !== 'localhost') {
    return `${window.location.protocol}//${host}`;
  }
  return `http://localhost:5001`;
}

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 15_000,
  headers: { 'Content-Type': 'application/json' },
});

// Attach stored token to every request
api.interceptors.request.use((config) => {
  try {
    const user = JSON.parse(localStorage.getItem('ams_user') || 'null');
    if (user?.token) {
      config.headers['Authorization'] = `Bearer ${user.token}`;
    }
  } catch {}
  return config;
});

// Redirect to login on 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('ams_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
